export class PortalInfo {
    PortalId: number;
    PortalTitle: string;
    PortalHeaderColor: string;
}
